import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';

import { AuthProvider } from '@/features/auth/AuthProvider';
import { AppConfigProvider } from '@/features/config/AppConfigProvider';
import { ThemeProvider } from '@/theme/ThemeProvider';

import { createQueryClient } from './queryClient';
import { router } from './router';

const queryClient = createQueryClient();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppConfigProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </AppConfigProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
